var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrchestrateByVeregyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "16 139 543 82",
    style: {
      enableBackground: "new 0 0 576 360"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#5C5C5C;}\r\n\t.st1{fill:#73B043;}\r\n\t.st2{fill:#195E88;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.8,159.2c13.1,0,22.9,8,22.9,19.1c0,11-9.7,19-22.9,19c-13.1,0-22.8-7.9-22.8-19 C108,167.2,117.7,159.2,130.8,159.2z M130.8,193c9.9,0,17.2-6.2,17.2-14.7c0-8.7-7.3-14.9-17.2-14.9c-9.8,0-17.1,6.2-17.1,14.9 C113.7,186.9,121,193,130.8,193z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M162.6,168.2H186c6.9,0,11.1,2.9,11.1,7.8c0,3.9-3.3,7.2-8.4,7.9l9.5,12.4h-5.8l-9.6-12.4h-14.9v12.4h-5.3 V168.2z M186,179.9c3.7,0,5.6-1.3,5.6-3.8c0-2.4-2-3.8-5.6-3.8h-18.2v7.6H186z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.8,189.5c-3.9,5-10.3,7.7-18.4,7.7c-12.1,0-20.6-6.3-20.6-14.8c0-8.5,8.5-14.9,20.6-14.9 c7.5,0,13.8,2.4,17.4,6.6l-4.2,2.4c-2.7-3.2-7.5-5-13.2-5c-8.8,0-15.2,4.6-15.2,10.8c0,6.1,6.4,10.8,15.2,10.8 c6.1,0,10.6-2,14.1-6.1L242.8,189.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.8,168.2h5.3v10.9H281v-10.9h5.4v28.1H281v-13.1h-23.9v13.1h-5.3V168.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.9,168.2h31.9v4.1h-26.7v7h17.5v4h-17.5v8.9h28.1v4h-33.4V168.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M338.6,189.1c4.9,2.7,10.8,4.1,15.5,4.1c6.4,0,10.2-2.4,10.2-5.5c0-3.3-3.5-4.7-10.6-4.8 c-10.5-0.1-16.3-1.3-16.3-7.3c0-4.7,5.2-8.1,14-8.1c5.9,0,11.4,1.4,16.5,4.1l-2.7,3.6c-4.4-2.4-9.6-3.7-13.9-3.7 c-5.4,0-8.6,1.7-8.6,4c0,2.7,3.5,3.4,10.6,3.4c11,0,16.5,3.1,16.5,9.1c0,5-5.7,9.2-15.2,9.2c-6.4,0-13.2-1.5-18.7-4.4L338.6,189.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387.5,172.1h-14.4v-3.9h34.1v3.9h-14.4v24.2h-5.3V172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.5,168.2H436c6.9,0,11.1,2.9,11.1,7.8c0,3.9-3.3,7.2-8.4,7.9l9.5,12.4h-5.8l-9.6-12.4h-14.9v12.4h-5.3 V168.2z M436,179.9c3.7,0,5.6-1.3,5.6-3.8c0-2.4-2-3.8-5.6-3.8h-18.2v7.6H436z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M466.3,168.2h3.3l17.5,28.1h-5.7l-4.4-7.1h-18l-4.4,7.1H449L466.3,168.2z M474.6,185.5l-6.6-10.8l-6.7,10.8 H474.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M497.8,172.1h-14.4v-3.9h34.1v3.9h-14.4v24.2h-5.3V172.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M522.8,168.2h31.9v4.1h-26.7v7h17.5v4h-17.5v8.9h28.1v4h-33.4V168.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409.9,205h10.8c3.6,0,5.4,1.3,5.4,3.7c0,1.2-0.6,2.1-1.6,2.7c1.9,0.9,2.9,2.3,2.9,4c0,2.7-2.3,4.5-6.2,4.5 h-11.3V205z M420.9,210.8c1.9,0,2.9-0.7,2.9-2.1c0-1.4-1-2.1-2.9-2.1h-8.7v4.2H420.9z M421.7,218.1c2.1,0,3.4-1.1,3.4-2.8 c0-1.6-1.2-2.8-3.3-2.8h-9.5v5.6H421.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.7,214l-6.4-5.6h2.8l4.7,4.1l4.6-4.1h2.9l-6.5,5.6v5.9h-2.2V214z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M455.3,205h2.5l7,11.9l7-11.9h2.5l-8.8,14.9h-1.4L455.3,205z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.5,208.3h13.2v1.7h-11v2.9h7.2v1.6h-7.2v3.6h11.6v1.6h-13.8V208.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M492.5,208.3h9.7c2.9,0,4.6,1.2,4.6,3.2c0,1.6-1.4,2.9-3.5,3.2l3.9,5.1h-2.4l-4-5.1h-6.2v5.1h-2.2V208.3z  M502.2,213.1c1.5,0,2.3-0.5,2.3-1.6c0-1-0.8-1.5-2.3-1.5h-7.5v3.1H502.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510.8,208.3H524v1.7h-11v2.9h7.2v1.6H513v3.6h11.6v1.6h-13.8V208.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M543.2,217.2c-1.6,1.9-4.3,3-7.8,3c-5.3,0-8.8-2.6-8.8-6.1c0-3.4,3.5-6.1,8.8-6.1c3.3,0,5.8,0.9,7.5,2.7 l-1.7,1c-1.2-1.3-3.3-2-5.8-2c-4,0-6.6,1.9-6.6,4.4s2.6,4.4,6.6,4.4c2.5,0,4.7-0.9,5.5-1.9v-1.2h-3.6v-1.6h5.8V217.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M550.2,214l-6.4-5.6h2.8l4.7,4.1l4.6-4.1h2.9l-6.5,5.6v5.9h-2.2V214z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "41.6,189.3 29.9,182.7 17.1,189.9 28.9,196.5 28.9,209.9 41.6,202.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "58.5,160.8 70.2,154.2 70.2,139.8 58.5,146.4 46.8,139.8 46.8,154.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "75.4,170.3 87.2,177 100,169.8 88.1,163.1 88.1,149.9 75.4,157.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "58.6,198.9 46.8,205.6 46.8,219.8 58.5,213.2 70.2,219.8 70.2,205.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "75.4,189.5 75.4,202.5 88.1,209.7 88.1,196.5 99.9,189.9 87.2,182.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "41.6,170.3 41.6,157.1 28.9,149.9 28.9,163.1 17.2,169.7 29.9,176.9  "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrchestrateByVeregyLogo);
export default __webpack_public_path__ + "static/media/orchestrate-by-veregy-logo.780962187592e77337440b7435c1a870.svg";
export { ForwardRef as ReactComponent };